import { Box } from '@chakra-ui/react';
import { List } from 'antd';
import React from 'react';
import { UserOutlined, CalendarOutlined } from '@ant-design/icons';
import RankingListItemMeta from './RankingListItemMeta';
import IconText from './IconText';

const RankingListItem = ({ rankingList, routePath }) => {
  return (
    <Box height="55vh" style={{ overflow: 'auto' }}>
      <List
        itemLayout="vertical"
        size="medium"
        dataSource={rankingList}
        renderItem={(rankingListItem) => (
          <List.Item
            actions={[
              <IconText
                icon={CalendarOutlined}
                text={rankingListItem.run_id}
                key="actions-0"
              />,
              <IconText
                icon={UserOutlined}
                text={rankingListItem.author_email}
                key="actions-1"
              />,
            ]}
          >
            <RankingListItemMeta
              rankingListItem={rankingListItem}
              routePath={routePath}
            />
          </List.Item>
        )}
      />
    </Box>
  );
};

export default RankingListItem;
